import isDev from '../dev-detect';

export const BASE_URL = isDev() ? process.env.REACT_APP_API_BASE_URL : '';
